export const cacheKey = "/engagement/user_directory_preview/:app_group_id" as const;
